import {
  EDIT_RECEIVER_POSTAL_NAME,
  EDIT_RECEIVER_STATE_NAME,
  EDIT_RECEIVER_STREET_NAME,
  EDIT_RECEIVER_SUBURB_NAME,
  RESET_EDIT_RECEIVER_INFORMATION_STORE,
} from 'constants';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import useForm from 'hooks/form/useForm';
import useGetConfig from 'hooks/useGetConfig';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import useReceiverAPI from '../hooks/useReceiverAPI';
import useUpdateReceiverStore from '../hooks/useUpdateReceiverStore';

const initialFormField =
  RESET_EDIT_RECEIVER_INFORMATION_STORE.residentialAddress;

const withUpdateReceiverResidentialAddressInitial = (Component) => {
  const UpdateReceiverResidentialAddressInitialComponent = (props) => {
    const { countryConfig } = props || {};

    const config = useGetConfig({ countryConfig });
    const {
      addressStreet: addressStreetConfig,
      addressState: addressStateConfig,
      addressSuburb: addressSuburbConfig,
      addressPostcode: addressPostcodeConfig,
      addressManualDisable: addressManualDisableConfig,
    } = config;

    const {
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    } = useForm(initialFormField);

    const [cities, setCities] = useState(null);
    const [portalCodeMaskStr, setPortalCodeMaskStr] = useState('');

    const { getCitiesRequest } = useReceiverAPI();

    const { currentReceiver, editReceiverInformation } =
      useFormAddReceiverStore();
    const { residentialAddress } = editReceiverInformation || {};
    const { address } = currentReceiver || {};
    const { street, city, suburb, postcode, manual } = address || {};

    const { isResidentialAddressInformationChanged } = useUpdateReceiverStore();

    useEffect(() => {
      if (isEmpty(currentReceiver)) return;
      if (isResidentialAddressInformationChanged) return;

      const newInformation = {
        [EDIT_RECEIVER_STREET_NAME]: street,
        [EDIT_RECEIVER_STATE_NAME]: city,
        [EDIT_RECEIVER_SUBURB_NAME]: suburb,
        [EDIT_RECEIVER_POSTAL_NAME]: postcode,
        isEditReceiverEnterAddressManuallySelected: manual,
      };
      console.log(
        `⭐ withUpdateReceiverResidentialAddressInitial 👉 useEffect ➡️ 1 ➡️ newInformation ↩`,
        newInformation,
      );
      setInformation(newInformation);
    }, [currentReceiver]);

    useEffect(() => {
      if (isEmpty(countryConfig)) return;

      getCitiesRequest({
        countryCode: countryConfig?.countryCode,
        callBack: (cities) => {
          setCities(cities);
        },
      });
    }, [countryConfig]);

    useEffect(() => {
      if (isEmpty(residentialAddress)) return;
      if (!isResidentialAddressInformationChanged) return;

      const informationStore = residentialAddress;

      const newInformation = {
        [EDIT_RECEIVER_STREET_NAME]:
          informationStore[EDIT_RECEIVER_STREET_NAME],
        [EDIT_RECEIVER_STATE_NAME]: informationStore[EDIT_RECEIVER_STATE_NAME],
        [EDIT_RECEIVER_SUBURB_NAME]:
          informationStore[EDIT_RECEIVER_SUBURB_NAME],
        [EDIT_RECEIVER_POSTAL_NAME]:
          informationStore[EDIT_RECEIVER_POSTAL_NAME],
        isEditReceiverEnterAddressManuallySelected:
          informationStore.isEditReceiverEnterAddressManuallySelected,
      };
      console.log(
        `⭐ withUpdateReceiverResidentialAddressInitial 👉 useEffect ➡️ 2 ➡️ newInformation ↩`,
        newInformation,
      );
      setInformation(newInformation);
    }, [
      residentialAddress,
      setInformation,
      isResidentialAddressInformationChanged,
    ]);

    const newProps = {
      ...props,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
      portalCodeMaskStr,
      setPortalCodeMaskStr,
      cities,
      addressStreetConfig,
      addressStateConfig,
      addressSuburbConfig,
      addressPostcodeConfig,
      addressManualDisableConfig,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverResidentialAddressInitialComponent;
};

export default withUpdateReceiverResidentialAddressInitial;
